import TextEditorConvertor from 'app/modules/textEditor/utils/textEditorConvertor';
import { MentionableUser } from 'types/User';

export function processRawMentions(
  comment: string,
  mentionableUsers: MentionableUser[],
) {
  return TextEditorConvertor.textToHtml(comment, {
    mentionableUsers: mentionableUsers.map((user) => ({
      id: user.id,
      name: `${user.name} ${user.last_name}`,
      image: user.avatar?.src,
      role: user.role,
    })),
  });
}
